import { defineMessages } from 'react-intl';

export default defineMessages({
  sponsored: {
    id: 'Sponsored',
    defaultMessage: 'Sponsored',
  },
  ourPartners: {
    id: 'our partners',
    defaultMessage: 'our partners',
  },
  modalSponsored: {
    id: 'Content created by <strong>{pageName}</strong> and sponsored by <strong>{pageSponsor}</strong>.',
    defaultMessage: 'Content created by <strong>{pageName}</strong> and sponsored by <strong>{pageSponsor}</strong>.',
  },
  factChecked: {
    id: 'Fact Checked',
    defaultMessage: 'Fact Checked',
  },
  modalFact: {
    id: 'The article has been verified to ensure the highest possible accuracy (the content includes links to accredited media sites, academic research institutions and, occasionally, medical studies). All the content of our website has been reviewed, however, if you consider that our content is inaccurate, outdated or doubtful, you can {contactLink} to make the necessary corrections.',
    defaultMessage: 'The article has been verified to ensure the highest possible accuracy (the content includes links to accredited media sites, academic research institutions and, occasionally, medical studies). All the content of our website has been reviewed, however, if you consider that our content is inaccurate, outdated or doubtful, you can {contactLink} to make the necessary corrections.',
  },
  evidenceBased: {
    id: 'Evidence Based',
    defaultMessage: 'Evidence Based',
  },
  modalEvidence: {
    id: 'The article is based on scientific evidence, and was written and reviewed by professionals (the content includes scientific references). All the content of our website has been reviewed, however, if you consider that our content is inaccurate, outdated or doubtful, you can {contactLink} to make the necessary corrections.',
    defaultMessage: 'The article is based on scientific evidence, and was written and reviewed by professionals (the content includes scientific references). All the content of our website has been reviewed, however, if you consider that our content is inaccurate, outdated or doubtful, you can {contactLink} to make the necessary corrections.',
  },
  contactUs: {
    id: 'contact us',
    defaultMessage: 'contact us'
  }
});
